import { useNavigate } from "react-router-dom";
import { LogOut, Plus, Phone } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { api, apiError } from "../../lib/api";
import { BRAND } from "../../lib/constants";

export function BrandMark({ size = 40 }) {
  return (
    <img src="/brand/logo-nillo.png" alt="Logo NILLO EQUIPAMENTOS" data-testid="brand-logo-image"
      style={{ height: size }} className="w-auto object-contain rounded-sm bg-white p-0.5" />
  );
}

export function Brand({ compact = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <BrandMark size={compact ? 40 : 64} />
      <div className="leading-none">
        <div className="font-display font-black text-xl sm:text-2xl tracking-wider text-white">NILLO <span className="text-[#FFD500]">EQUIPAMENTOS</span></div>
        {!compact && <div className="font-display font-bold text-xs tracking-[0.12em] text-[#FFD500] mt-1.5" data-testid="brand-tagline">COMPRE SEU ALINHADOR DESEMPENADOR DE CHASSIS</div>}
      </div>
    </div>
  );
}

export function useNewInspection() {
  const nav = useNavigate();
  const { user } = useAuth();
  return async () => {
    const now = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    try {
      const { data } = await api.post("/inspections", {
        vehicle: {
          executor: user?.name || "",
          data_inspecao: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`,
          hora_inspecao: `${pad(now.getHours())}:${pad(now.getMinutes())}`,
        },
      });
      nav(`/inspecao/${data.id}`);
      toast.success("Nova inspeção criada");
    } catch (e) {
      toast.error(apiError(e));
    }
  };
}

export function AppHeader({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-[#050B10]/90 backdrop-blur-md border-b border-[#1E2F45]" data-testid="app-header">
      <div className="h-1 hazard-stripe opacity-90" />
      <div className="px-4 sm:px-6 h-16 flex items-center gap-4">
        <button type="button" onClick={() => nav("/")} data-testid="header-home-link"><Brand compact /></button>
        <div className="flex-1 flex items-center gap-2 min-w-0">{children}</div>
        <div className="hidden md:flex flex-col items-end leading-tight">
          <span className="text-sm font-semibold text-white" data-testid="header-user-name">{user?.name}</span>
          <span className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{user?.role === "admin" ? "Administrador" : "Executor"}</span>
        </div>
        <button type="button" onClick={logout} data-testid="logout-button" title="Sair"
          className="h-9 w-9 flex items-center justify-center rounded-sm border border-[#1E2F45] text-slate-300 hover:text-white hover:border-[#FFD500]/60 transition-colors">
          <LogOut size={16} />
        </button>
      </div>
    </header>
  );
}

export function NewInspectionButton({ className = "" }) {
  const create = useNewInspection();
  return (
    <button type="button" onClick={create} data-testid="btn-nova-inspecao"
      className={`h-10 px-4 inline-flex items-center gap-2 bg-[#FFD500] text-[#050B10] font-display font-bold tracking-wider text-base rounded-sm hover:bg-[#E6C000] active:scale-[0.98] transition-[background-color,transform] ${className}`}>
      <Plus size={18} strokeWidth={3} /> NOVA INSPEÇÃO
    </button>
  );
}

export function AppFooter() {
  return (
    <footer className="border-t border-[#1E2F45] bg-[#050B10]" data-testid="app-footer">
      <div className="px-4 sm:px-6 py-5 flex flex-col lg:flex-row gap-3 lg:items-center justify-between">
        <div>
          <div className="font-display font-extrabold tracking-wider text-white">{BRAND.empresa}</div>
          <div className="font-mono text-[10px] tracking-widest text-slate-500">{BRAND.atividade}</div>
        </div>
        <div className="font-display font-bold tracking-[0.18em] text-[#FFD500] text-sm">{BRAND.frase}</div>
        <div className="flex items-center gap-2 font-mono text-xs text-slate-300">
          <Phone size={14} className="text-[#FFD500]" /> WhatsApp {BRAND.whatsapp || BRAND.telefone} · {BRAND.atendimentoRodape}
        </div>
      </div>
    </footer>
  );
}
